import React from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthUser } from "hooks/useAuthUser";
import { AdminRoutes } from "config/routes";
import { consumeFeedbackReturnPath } from "services/accountSession";

export const PublicLayout: React.FC = () => {
  const { token } = useAuthUser();
  const location = useLocation();
  const isAuthCallback = location.pathname === AdminRoutes.AuthCallback;
  if (token && !isAuthCallback) {
    const returnPath =
      location.pathname === AdminRoutes.Login
        ? consumeFeedbackReturnPath()
        : null;
    return <Navigate to={returnPath || AdminRoutes.Home} replace />;
  }
  return <Outlet />;
};
